import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgClass, AsyncPipe, NgFor, NgIf } from '@angular/common';
import { FaqService } from '../../../../core/services/faq.service';
import { Faq, FaqList, FindedFaq } from '../../../../core/interfaces/faq.interface';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClickOutsideDirective, CutStringPipe, HighlightPipe } from '@wm-libs/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: true,
  imports: [NgClass, AsyncPipe, HighlightPipe, CutStringPipe, TranslateModule, NgFor, NgIf, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, ClickOutsideDirective],
})
export class FaqComponent implements OnInit {
  faqList: FaqList[] | null = null;
  selectedFaq: Faq | null = null;
  searchForm!: FormGroup;

  modifiedFaq: Faq[] = [];
  findedFaq: FindedFaq[] = [];

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  constructor(private breakpointObserver: BreakpointObserver, private faqService: FaqService, public tr: TranslateService, private formBuilder: FormBuilder) {
    this.searchForm = this.formBuilder.group({ searchControl: '' });
  }

  ngOnInit(): void {
    this.faqService.getFaq().subscribe((res) => {
      this.faqList = res;

      for (const item of this.faqList) {
        this.modifiedFaq = this.modifiedFaq.concat(item.faqs);
      }
    });

    this.searchForm.valueChanges.subscribe((value) => {
      this.search(value.searchControl);
    });
  }

  selectFaq(faq: Faq) {
    this.selectedFaq = faq;
    this.findedFaq = [];
    this.searchForm.controls['searchControl'].setValue('');
  }

  search(value: string) {
    this.findedFaq = [];

    if (!value) {
      return;
    }

    for (const item of this.modifiedFaq) {
      const questionText = this.tr.currentLang === 'en' ? item.question_en : item.question_ru;
      const answerText = this.tr.currentLang === 'en' ? item.answer_en : item.answer_ru;
      const searchTerm = value.toLowerCase();

      const questionMatches = this.getHighlightedText(questionText, searchTerm);
      const answerMatches = this.getHighlightedText(answerText, searchTerm);

      if (questionMatches) {
        this.findedFaq.push({ item, finded: questionMatches });
      }

      if (answerMatches) {
        this.findedFaq.push({ item, finded: answerMatches });
      }
    }
  }
  getHighlightedText(text: string, searchTerm: string): string | null {
    const re = new RegExp(`(?:\\S+\\s){0,3}\\S*${searchTerm}\\S*(?:\\s\\S+){0,3}`, 'gi');
    let match;
    let result = '';

    while ((match = re.exec(text)) !== null) {
      const [prefix, search, suffix] = match[0].split(new RegExp(`(${searchTerm})`, 'gi'));
      result += `${prefix}<span class="bold">${search}</span>${suffix}... `;
      if (result.split('<span class="bold">').length - 1 >= 3) {
        break;
      }
    }

    return result ? result.trim() : null;
  }

  onOutsideClick() {
    this.findedFaq = [];
    this.searchForm.controls['searchControl'].setValue('');
  }
}
